import $ from "jquery";
import Flickity from "flickity";
import "../vendors/flickity-imagesloaded/flickity-imagesloaded.js";

class NewsSlider {
	constructor($el) {
		this.$el = $el;

		this.options = {
			autoPlay: true,
			pageDots: false,
			wrapAround: true,
			prevNextButtons: true,
			freeScroll: true,
            cellAlign: 'center',
            imagesLoaded: true,
			cellSelector: ".last-news-section__slider__card",
            arrowShape: { 
                x0: 10,
                x1: 60, y1: 50,
                x2: 65, y2: 50,
                x3: 15
            },
            on: {
                ready: this._resize.bind(this)
            }
		};

		if (this.$el.length) {
            this._init();
            this._resize();
            this._bindEvents();
		}
	}

    _init() {
        this.$slides = this.$el.find('.last-news-section__slider__card');
        this.slidesCount = this.$slides.length;

        if(document.body.clientWidth < 1400 && this.slidesCount > 0) {
            this._createSlider();
            // console.log('slider');
        } else if (document.body.clientWidth >= 1400 && this.slidesCount < 4) {
            this._destroy();
            // console.log('no slider');
        } else {
            this._createSlider();
        }
    }

    _bindEvents() {
        this.resizeFn = this._resize.bind(this);

        document.addEventListener('load', this.resizeFn);
        document.addEventListener('webfont:loaded', this.resizeFn);
    }

	_createSlider() {
        this.slider = new Flickity(this.$el[0], this.options);
    }

    _destroy() {
        if(this.slider) {
            this.slider.destroy();
            this.slider = null;
        }
    }

    _resize() {
        if(this.slider) {
            this.slider.resize();
        }
    }
}

export default NewsSlider;